/** Central session configuration — adjust timeouts here */

/** Minutes of inactivity before automatic logout */
export const IDLE_TIMEOUT_MINUTES = 15;

/** Minutes before logout to show warning modal */
export const WARNING_BEFORE_MINUTES = 2;

/** Derived values in milliseconds (do not edit) */
export const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MINUTES * 60 * 1000;
export const WARNING_BEFORE_MS = WARNING_BEFORE_MINUTES * 60 * 1000;
